import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";

// local imports
import CustomInput from '../../components/atoms/Input';
import CustomButton from '../../components/atoms/Button';
import { appActions, productActions } from '../../store/slices';
import { addProduct, editProduct } from '../../service/product';
import Footer from '../../components/organisms/Footer';
import { UtilityFunctions } from '../../utils';
import DragAndDrop from '../../components/organisms/DragAndDrop';

function AddProduct() {
    const params = useParams();
    const navigate = useNavigate();
    const [disabled, setDisabled] = useState(true);
    const isLoading = useSelector((state) => state.app.isLoading);
    const dispatch = useDispatch();
    const [productId, setProductId] = useState(params.id);
    const { user } = useSelector((state) => state.auth);
    const products = useSelector((state) => state.product.products);
    const product = useSelector(state => state.product.product);
    const { name, code } = product;

    const [errors, setErrors] = useState({
        name: '',
        code: '',
        description: ''
    });

    const handleInput = (e) => {

        const { name, value } = e.target;

        dispatch(productActions.setProduct({
            ...product,
            [name]: value
        }));

        setErrors({
            ...errors,
            [name]: '',
        })
    };

    const submitProductHandler = async (e) => {
        e.preventDefault();

        const validatedForm = UtilityFunctions.validateForm('addProduct', errors, { name: product.name, code: product.code });

        if (validatedForm.error) {
            setErrors(validatedForm.errors);
            return;
        }

        const addOrEditProduct = productId ? editProduct({ id: productId, ...product, user }) : addProduct({ ...product, user });

        try {
            dispatch(appActions.setLoading(true));
            const data = await addOrEditProduct;
            setTimeout(() => {
                navigate('/factory/products');
                dispatch(productActions.clearProduct());
            }, 2000)
        } catch (err) {
            console.log(err);
        } finally {
            dispatch(appActions.setLoading(false));
        }

    };

    // to determine if submit button should be disabled or not
    useEffect(() => {
        if (isLoading || !name || !code) {
            setDisabled(true);
        } else if (!isLoading && name && code) {
            setDisabled(false);
        }
    }, [code, isLoading, name]);

    // set the values if the product is being edited
    useEffect(() => {
        if (productId) {
            const productToBeEdited = products.find(product => product.id === productId);
            const { id, ...rest } = productToBeEdited
            dispatch(productActions.setEditProduct(rest));
        }
    }, [productId])

    return (
        <>
            <div className='product-container main-container'>
                <div className='add-product-form padding-vertical-80'>
                    <Form className='product-left'>
                        <h2>Ürün Ekle</h2>
                        <CustomInput
                            id={'product-name'}
                            name={'name'}
                            value={product.name}
                            label={'Ürün adı'}
                            placeholder={'Ürün adını giriniz'}
                            onChange={handleInput}
                            error={errors.name}
                        />
                        <CustomInput
                            id={'product-code'}
                            name={'code'}
                            value={product.code}
                            label={'Ürün kodu'}
                            placeholder={'Ürün kodunu giriniz'}
                            onChange={handleInput}
                            error={errors.code}
                        />
                        <Form.Group>
                            <Form.Label>Ürün Açıklaması</Form.Label>
                            <Form.Control
                                as='textarea'
                                rows={3}
                                id={'product-description'}
                                name={'description'}
                                value={product.description}
                                onChange={handleInput}
                                placeholder={'Ürün açıklamasını giriniz'}
                                className='custom-text-area'
                            />
                        </Form.Group>
                    </Form>
                    <DragAndDrop title="Ürün Görseli Ekle" />
                </div>
            </div>
            <Footer backButton>
                <CustomButton
                    onClick={submitProductHandler}
                    async
                    title='Kaydet'
                    variant={'success'}
                    loading={isLoading}
                    disabled={disabled}
                />
            </Footer>
        </>
    );
}
export default AddProduct;
